import { Component, ViewChild } from '@angular/core';
import {
  Message,
  TreeNode,
  SelectItem,
  ConfirmationService,
  ConfirmEventType,
} from 'primeng/api';
import { Table } from 'primeng/table';
import {
  link,
  breadcrumb,
  stat,
} from 'src/app/admin/layout/header/header.component';
import { DynamicFormComponent } from 'src/app/misc/component/dynamic-form/dynamic-form.component';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { DropdownQuestion } from 'src/app/misc/component/dynamic-form/question-dropdown';
import { TextboxQuestion } from 'src/app/misc/component/dynamic-form/question-textbox';
import { DataService } from 'src/app/services/data.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import icons from '../../../../misc/data/icons.json';


import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { IconBoxQuestion } from 'src/app/misc/component/dynamic-form/question-iconbox';

@Component({
  selector: 'app-k-category',
  templateUrl: './k-category.component.html',
  styleUrls: ['./k-category.component.scss'],
})
export class KCategoryComponent {
  skelition = true;

  @ViewChild(DynamicFormComponent) DynamicFormComponent:
    | DynamicFormComponent
    | any;

  @ViewChild('dt')
  dt!: Table;

  messages: Message[] = [];
  translator: TranslatorPipe = new TranslatorPipe()

  cols: any[] = [];
  exportColumns: { title: any; dataKey: any }[] = [];

  treedata: TreeNode[] = [];
  header = this.translate('Category');
  links: link[] = [
    {
      name: this.translate('Back'),
      icon: 'pi pi-chevron-circle-right',
      link: '/dashboard/knowledge-library',
      visible: this.permissionService.hasPermission('KNOWLEDGE_LIBRARY', 'r')
    },
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Knowledge Library'), link: '/dashboard/knowledge-library' },
    { name: this.translate('Category'), link: '/dashboard/knowledge-library/category' },
  ];
  stats: stat[] = [];

  categoryData: any[] = [];

  data: any[] = [];
  iconOptions: SelectItem[] = [];
  questions: QuestionBase<string>[] = [];

  deleteModal: boolean = false;
  deleteData: any;

  // Update data
  updateModal = false;
  updateData: any;
  updateQuestions: any;
  transferData: boolean = true;
  changeCategory: any;
  deleteMessage: any = [];

  constructor(
    public dataService: DataService,
    private confirmationService: ConfirmationService,
    public permissionService: PermissionHandlerService
  ) { }

  ngOnInit() {
    icons.forEach((icon: { i: string; n: string }) => {
      this.iconOptions.push({ label: icon.n, icon: icon.i, value: icon.i });
    });

    this.iconOptions = this.iconOptions.sort((a, b) => {
      if (a.label && b.label) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      } else {
        return 0;
      }
    });
    this.getCategories().then((e) => {
      this.skelition = false;
    });
    this.makequestion();
  }

  // Add New Interface

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  makequestion() {
    this.questions = [
      new TextboxQuestion({
        key: 'name',
        label: 'العنوان',
        required: true,
        order: 1,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
      }),

      new IconBoxQuestion({
        key: 'icon',
        label: 'الايقونات',
        required: true,

        filter: true,
        order: 3,
        className: 'col-md-12 col-sm-12 col-12',
      }),
    ];
  }

  addCategory = async ($event: any) => {
    try {
      let data = $event;
      let res = await this.dataService.postData(
        'knowledge-library-category',
        data
      );
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.DynamicFormComponent.resetForm();
      this.getCategories();
    } catch (error) {
      console.log(error);
    }
  };

  updateCategory = async ($event: any) => {
    try {
      let data: any = $event;
      data._id = this.updateData._id;
      let res = await this.dataService.postData(
        'knowledge-library-category',
        data,
        'PUT',
        false
      );
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.updateModal = false;
      this.updateData = undefined;
      // updating in table
      this.getCategories();
    } catch (error) {
      console.log(error);
    }
  };

  // Add Table Configuration
  getCategories = async () => {
    this.skelition = true;
    this.data = [];
    try {
      let res = await this.dataService.getData('knowledge-library-category');
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.categoryData = res.data;
      this.categoryData.forEach((item: any) => {
        this.data.push({
          '#': { n: item._id, i: 'pi pi-angle-left' },
          'اسم الواجهة': { n: item.name, i: 'pi pi-' + item.icon },
          Action: item.name == "التدريبات" ? [] : [
            {
              n: 'Delete',
              i: 'pi pi-times',
              s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
            },
            {
              n: 'Update',
              i: 'pi pi-file-edit',
              s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
            },
          ],
        });
      });
      this.skelition = false;
    } catch (error) {
      console.log(error);
    }
  };

  getFilteredCategories() {
    return this.categoryData.filter((e: any) => e._id != this.deleteData);
  }

  actionCall($event: any) {
    switch ($event.action) {
      case 'Delete':
        this.deleteModal = true;
        this.deleteData = $event.id;
        break;
      case 'Update':
        this.updateData = this.categoryData.find(
          (item) => item._id == $event.id
        );
        this.updateQuestions = [
          new TextboxQuestion({
            key: 'name',
            label: 'العنوان',
            required: true,
            order: 1,
            icon: 'pi pi-file',
            value: this.updateData.name,
            className: 'col-md-12 col-sm-12 col-12',
          }),

          new IconBoxQuestion({
            key: 'icon',
            label: 'الايقونات',
            required: true,

            filter: true,
            value: this.updateData.icon,
            order: 3,
            className: 'col-md-12 col-sm-12 col-12',
          }),
        ];
        // console.log("Update Data ==>",this.categoryData,this.updateData);
        this.updateModal = true;
        break;
      default:
        console.log('Unknown color');
        break;
    }
  }
  deleteCategory = async () => {
    console.log(this.transferData, this.changeCategory, this.deleteData);
    if (!this.deleteData) {
      return;
    }
    if (this.transferData && !this.changeCategory) {
      this.deleteMessage = [
        {
          severity: 'error',
          summary: this.translate('error'),
          detail: 'Please select a category',
        },
      ];
      return;
    }
    try {
      let res = await this.dataService.postData(
        `knowledge-library-category/delete`,
        {
          _id: this.deleteData,
          deleteData: this.transferData ? 0 : 1,
          changeCategory: this.transferData ? this.changeCategory : {},
        }
      );
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.transferData = true;
      this.changeCategory = {};
      this.deleteData = '';
      this.deleteModal = false;
      this.getCategories();
    } catch (error) {
      console.log(error);
    }
  };
  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }
}
